/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_ReloadInputs */

const vi_shop_home_reload = /** @type {(inputs: Shop_Home_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải lại`)
};

/**

* @param {Shop_Home_ReloadInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_reload = /** @type {((inputs?: Shop_Home_ReloadInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_ReloadInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_reload(inputs)
});